export default __webpack_public_path__ + "static/media/logo-determined-on-dark-vertical.c826e970.svg";